module.exports = __webpack_public_path__ + "static/media/education_n.cc032a67.png";